//import { useLocalizeField } from "~/l10n";

import Disclaimer from "~/pages/schnelltest/partials/Disclaimer";

export function ExitMieterhoehungStaffelmietvertragFreiwillig() {
  //const l = useLocalizeField();

  return (
    <>
      <h2>Du musst der Mieterhöhung wahrscheinlich nicht zustimmen.</h2>
      <p>TODO</p>
      <h3>Was nun?</h3>
      <p>Bitte überprüfe zunächst, ob die folgenden Angaben stimmen:</p>
      <ol>
        <li>Item</li>
      </ol>
      <Disclaimer />
    </>
  );
}
